<script>
  import Layout from "@/components/pages/layouts/vertical";
  import PageHeader from "@/components/page-header";
  import { mapActions, mapState, mapGetters  } from 'vuex';
  import PhotoManager from "@/components/widgets/photo-manager";
  import { mapKeys, snakeCase } from 'lodash';
  import categories from './constants';


  export default {
    name: 'Area',
    data() {
      return {
        name: '',
        category: '',
        nickname: '',
        ceiling_height: '',
        floor_material_type: '',
        counter_top_material: '',
        counter_top_measurement: '',
        wall_material: '',
        additional_information: '',
        
        item: {
          name: '',
          category: '',
          subCategory: '',
          note: '',
          description: '',
          approximatePrice: '',
          brandName: '',
          manufacturer: '',
          modelNumber: '',
          serialNumber: '',
          perPieceOrPerSet: '',
          numberOfItems: '',
          dimensions: '',
          itemWeight: '',
          measurementWidth: '',
          measurementHeight: '',
          measurementDepth: '',
          yearPurchased: '',
          monthPurchased: '',
          country: '',
          condition: '',
          warrantyYears: '',
          serviceContractCompany: '',
          extendedWarrantyCompany: '',
          heirAssignedName: '',
          appraisalValue: '',
          actualCashValue: '',
          replacementCostValue: '',
          auctionValue: '',
          retailValue: '',
          assetOwnershipStatus: '',
          assetAssignedTo: ''
        },
        nameOptions: ["AC CLOSET 1", "AC CLOSET 2", "AC CLOSET 3", "AC CLOSET 4", "ATTIC", "BALCONY", "BAR AREA", "BASEMENT", "BATHROOM 1", "BATHROOM 1 CLOSET", "BATHROOM 10", "BATHROOM 10 CLOSET", "BATHROOM 11", "BATHROOM 11 CLOSET", "BATHROOM 12", "BATHROOM 12 CLOSET", "BATHROOM 2", "BATHROOM 2 CLOSET", "BATHROOM 3", "BATHROOM 3 CLOSET", "BATHROOM 4", "BATHROOM 4 CLOSET", "BATHROOM 5", "BATHROOM 5 CLOSET", "BATHROOM 6", "BATHROOM 6 CLOSET", "BATHROOM 7", "BATHROOM 7 CLOSET", "BATHROOM 8", "BATHROOM 8 CLOSET", "BATHROOM 9", "BATHROOM 9 CLOSET", "BEDROOM 1", "BEDROOM 1 CLOSET 1", "BEDROOM 1 CLOSET 2", "BEDROOM 10", "BEDROOM 10 CLOSET 1", "BEDROOM 10 CLOSET 2", "BEDROOM 11", "BEDROOM 11 CLOSET 1", "BEDROOM 11 CLOSET 2", "BEDROOM 12", "BEDROOM 12 CLOSET 1", "BEDROOM 12 CLOSET 2", "BEDROOM 13", "BEDROOM 13 CLOSET 1", "BEDROOM 13 CLOSET 2", "BEDROOM 14", "BEDROOM 14 CLOSET 1", "BEDROOM 14 CLOSET 2", "BEDROOM 15", "BEDROOM 15 CLOSET 1", "BEDROOM 15 CLOSET 2", "BEDROOM 2", "BEDROOM 2 CLOSET 1", "BEDROOM 2 CLOSET 2", "BEDROOM 3", "BEDROOM 3 CLOSET 1", "BEDROOM 3 CLOSET 2", "BEDROOM 4", "BEDROOM 4 CLOSET 1", "BEDROOM 4 CLOSET 2", "BEDROOM 5", "BEDROOM 5 CLOSET 1", "BEDROOM 5 CLOSET 2", "BEDROOM 6", "BEDROOM 6 CLOSET 1", "BEDROOM 6 CLOSET 2", "BEDROOM 7", "BEDROOM 7 CLOSET 1", "BEDROOM 7 CLOSET 2", "BEDROOM 8", "BEDROOM 8 CLOSET 1", "BEDROOM 8 CLOSET 2", "BEDROOM 9", "BEDROOM 9 CLOSET 1", "BEDROOM 9 CLOSET 2", "BEDROOM HALLWAY", "CABANA", "CLOSET", "DEN", "DINETTE AREA", "DINING ROOM", "DINING ROOM 2", "EXTERIOR BACK", "EXTERIOR FRONT", "EXTERIOR LEFT SIDE OF FRONT", "EXTERIOR RIGHT SIDE OF FRONT", "FAMILY ROOM", "FLORIDA ROOM", "FOYER", "FOYER CLOSET", "GARAGE", "GYM/WORKOUT ROOM", "HALLWAY", "HALLWAY CLOSET", "HOME GYM", "HOME THEATER", "KITCHEN", "KITCHEN 2", "LAUNDRY", "LIBRARY/STUDY", "LINEN CLOSET", "LIVING ROOM", "LOFT", "MASTER BATHOOM CLOSET", "MASTER BATHROOM", "MASTER BEDROOM", "MASTER BEDROOM CLOSET 1", "MASTER BEDROOM CLOSET 2", "MASTER BEDROOM CLOSET 3", "MASTER BEDROOM CLOSET 4", "MOTHER IN LAW SUITE", "MUD ROOM", "NON BEDROOM or BATHROOM CLOSETS", "OFFICE 1", "OFFICE 2", "OTHER ROOM 1", "OTHER ROOM 10", "OTHER ROOM 11", "OTHER ROOM 12", "OTHER ROOM 2", "OTHER ROOM 3", "OTHER ROOM 4", "OTHER ROOM 5", "OTHER ROOM 6", "OTHER ROOM 7", "OTHER ROOM 8", "OTHER ROOM 9", "PANTRY", "PATIO/DECK", "PLAYROOM/REC ROOM", "PORCH", "ROOF", "SHED", "STAIRS/STAIRWAY", "STORAGE AREA UNDER STAIRWELL", "SUN ROOM", "UTILITY ROOM", "WINE CELLAR"],
        floorMaterialTypeOptions: ["TILE", "MARBLE", "STONE", "WOOD HARDWOOD", "WOOD ENGINEERED", "LAMINATE", "VINYL", "LINOLEUM", "CARPETING", "CONCRETE OR RESIN", "CORK", "BAMBOO", "OTHER"],
        counterTopMaterialOptions: ["GRANITE", "QUARTZ", "MARBLE", "STONE", "TILE CERAMIC OR PORCELAIN", "GLASS", "SOAPSTONE", "SOLID SURFACE", "LAMINATE", "WOOD", "STAINLESS STEEL", "CONCRETE", "GLASS C", "OTHER"],
        wallMaterialOptions: ["PAINTED", "WALLPAPER", "PANELING", "GLASS", "BRICK", "TILES", "MIRROR", "METAL", "VINYL", "CONCRETE", "PLASTIC", "OTHER"],
        conditionOptions: ['EXCELLENT', 'VERY GOOD', 'GOOD', 'AVERAGE', 'BELOW AVERAGE', 'OTHER'],
        categoryOptions: Object.keys(categories),
        subCategoryOptions: [],
        perPieceOrPerSetOptions: ['Per Piece', 'Per Set', 'Other'],
        otherPerPieceOrPerSet: '',
        monthOptions: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        assetOwnershipStatusOptions: ['Marital', 'Non-Marital'],
      };
    },
    computed: {
      ...mapState('notification', {
        notificationType: state => state.type,
        notificationMessage: state => state.message
      }),
      ...mapGetters("area", ["selectedArea", "selectedPropertyAreas"]),
      photos() {
        return this.selectedArea.photos;
      },
      areaNameOptions() {
        const createdRooms = this.selectedPropertyAreas.map(area => area.name);
        const nameOptions = this.nameOptions.filter(name => name === this.selectedArea.name || !createdRooms.includes(name));

        return nameOptions;
      }
    },
    methods: {
      ...mapActions("area", ["updateArea"]),
      ...mapActions("item", ["createItem"]),
      setAreaFormData() {
        this.name = this.selectedArea.name;
        this.nickname = this.selectedArea.nickname;
        this.category = this.selectedArea.category;
        this.ceiling_height = this.selectedArea.ceiling_height;
        this.floor_material_type = this.selectedArea.floor_material_type;
        this.counter_top_material = this.selectedArea.counter_top_material;
        this.counter_top_measurement = this.selectedArea.counter_top_measurement;
        this.wall_material = this.selectedArea.wall_material;
        this.additional_information = this.selectedArea.additional_information;
      },
      resetItemFormData() {
        this.item.name = '';
        this.item.category = '';
        this.item.subCategory = '';
        this.item.note = '';
        this.item.description = '';
        this.item.approximatePrice = '';
        this.item.brandName = '';
        this.item.manufacturer = '';
        this.item.modelNumber = '';
        this.item.serialNumber = '';
        this.item.perPieceOrPerSet = '';
        this.item.numberOfItems = '';
        this.item.dimensions = '';
        this.item.itemWeight = '';
        this.item.measurementWidth = '';
        this.item.measurementHeight = '';
        this.item.measurementDepth = '';
        this.item.yearPurchased = '';
        this.item.monthPurchased = '';
        this.item.country = '';
        this.item.condition = '';
        this.item.warrantyYears = '';
        this.item.serviceContractCompany = '';
        this.item.extendedWarrantyCompany = '';
        this.item.heirAssignedName = '';
        this.item.appraisalValue = '';
        this.item.actualCashValue = '';
        this.item.replacementCostValue = '';
        this.item.auctionValue = '';
        this.item.retailValue = '';
        this.item.assetOwnershipStatus = '';
        this.item.assetAssignedTo = '';
      },
      tryToUpdateArea() {
        const payload = {
          name: this.name,
          category: this.category,
          nickname: this.nickname,
          ceiling_height: this.ceiling_height,
          floor_material_type: this.floor_material_type,
          counter_top_material: this.counter_top_material,
          counter_top_measurement: this.counter_top_measurement,
          wall_material: this.wall_material,
          additional_information: this.additional_information,
        };

        this.updateArea(payload);
      },
      tryToCreateItem() {
        let payload = mapKeys(this.item, (_, key) => snakeCase(key));

        if (payload.per_piece_or_per_set == "Other") {
          payload.per_piece_or_per_set = this.otherPerPieceOrPerSet
        }
        this.createItem(payload);
      },
      onPerPieceOrPerSetChange() {
        // Reset otherPerPieceOrPerSet if a different option is selected
        if (this.item.perPieceOrPerSet !== 'Other') {
          this.otherPerPieceOrPerSet = '';
        }
      },
      updateSubCategoryOptions() {
        const selectedCategory = this.item.category;
        if (categories[selectedCategory]) {

          this.subCategoryOptions = categories[selectedCategory];
        } else {
          this.subCategoryOptions = [];
        }
      },
      addPhoto() {
      },
    },
    mounted() {
      this.updateSubCategoryOptions();
    },
    watch: {
      'item.category': function() {
        this.updateSubCategoryOptions();
      }
    },
    components: { Layout, PageHeader, PhotoManager }
  }
</script>

<template>
  <Layout>
    <PageHeader class="m-0"></PageHeader>
    <b-row v-if="selectedArea">
      <b-col xl="7">
        <PhotoManager manageFor="area" :photos="photos" />
      </b-col>
      <b-col xl="5">
        <div v-if="notificationMessage" :class="'alert ' + notificationType">
          {{ notificationMessage }}
        </div>
        <div class="card">
          <div class="card-body">
            <table class="table mb-0 table-bordered border-black">
              <tbody>
                <tr v-if="$can('create', 'Item')">
                  <td colspan="2"></td>
                  <td class="text-center">
                    <b-button class="px-2" v-b-modal.modal-createItem variant="success" @click="resetItemFormData()">
                      Add Item
                    </b-button>
                  </td>
                </tr>
                <tr v-if="$can('update', 'Item')">
                  <td colspan="2" style="vertical-align:bottom"><h5>{{this.selectedArea.name}}</h5></td>
                  <td class="text-center">
                    <b-button v-b-modal.modal-updateArea variant="" @click="setAreaFormData()">
                      Update
                    </b-button>
                  </td>
                </tr>
                <!---<tr>
                  <td>Category</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.category}}</td>
                </tr>--->
                <tr>
                  <td>Nick Name</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.nickname}}</td>
                </tr>
                <tr>
                  <td>Ceiling Height</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.ceiling_height}}</td>
                </tr>
                <tr>
                  <td>Floor Material Type</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.floor_material_type}}</td>
                </tr>
                <tr>
                  <td>Counter Top Materials</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.counter_top_material}}</td>
                </tr>
                <tr>
                  <td>Counter Top Measurement</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.counter_top_measurement}}</td>
                </tr>
                <tr>
                  <td>Wall Material</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.wall_material}}</td>
                </tr>
                <tr>
                  <td>Additional Information</td>
                  <td colspan="2" style="vertical-align:bottom">{{this.selectedArea.additional_information}}</td>
                </tr>
                <tr>
                  <td colspan="4" style="vertical-align:bottom"><h5>Items</h5></td>
                </tr>
                <tr v-for="(item,index) in this.selectedArea.items" :key="index">
                  <td colspan="2"> {{ item.name }} </td>
                  <td colspan="1" class="px-5">
                    <router-link :to="`/properties/${$route.params.propId}/areas/${$route.params.areaId}/items/${item.id}`">Detail</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <b-modal id="modal-updateArea" title="Update Area" @ok="tryToUpdateArea">
              <div>
                <form>
                  <b-form-group
                    class="mb-3"
                    label="Name"
                    label-for="name-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="name-input"
                      v-model="name"
                      :options="areaNameOptions"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="NickName"
                    label-for="nickname-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="nickname-input"
                      type="text"
                      v-model="nickname"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="CeilingHeight"
                    label-for="ceiling_height-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="ceiling_height-input"
                      type="text"
                      v-model="ceiling_height"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="FloorMaterialType"
                    label-for="floor_material_type-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="floor_material_type-input"
                      v-model="floor_material_type"
                      :options="floorMaterialTypeOptions"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="CounterTopMaterial"
                    label-for="counter_top_material-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="counter_top_material-input"
                      v-model="counter_top_material"
                      :options="counterTopMaterialOptions"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="CounterTopMeasurement"
                    label-for="counter_top_measurement-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="counter_top_measurement-input"
                      type="text"
                      v-model="counter_top_measurement"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="WallMaterial"
                    label-for="wall_material-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="wall_material-input"
                      v-model="wall_material"
                      :options="wallMaterialOptions"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="AdditionalInformation"
                    label-for="additional_information-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="additional_information-input"
                      type="text"
                      v-model="additional_information"
                    ></b-form-input>
                  </b-form-group>
                  <!---<b-form-group
                    class="mb-3"
                    label="Item Category"
                    label-for="category-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="category-input"
                      type="text"
                      v-model="category"
                    ></b-form-input>
                  </b-form-group>--->
                </form>
              </div>
            </b-modal>
            <b-modal id="modal-createItem" title="Create Item" @ok="tryToCreateItem">
              <div>
                <form>
                  <b-form-group
                    class="mb-3"
                    label="Item Category"
                    label-for="category-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="category-input"
                      v-model="item.category"
                      :options="categoryOptions"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Product Type"
                    label-for="subCategory-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="subCategory-input"
                      v-model="item.subCategory"
                      :options="subCategoryOptions"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Item Name"
                    label-for="name-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="name-input"
                      type="text"
                      v-model="item.name"
                    ></b-form-input>
                  </b-form-group>

                   <b-form-group
                    class="mb-3"
                    label="Condition"
                    label-for="condition-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="condition-input"
                      v-model="item.condition"
                      :options="conditionOptions"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="Full Dimensions (inches)"
                    label-for="dimensions-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="dimensions-input"
                      type="text"
                      v-model="item.dimensions"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Item Weight (Grams)"
                    label-for="itemWeight-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="itemWeight-input"
                      type="text"
                      v-model="item.itemWeight"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="Measurement-Height"
                    label-for="measurementHeight-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="measurementHeight-input"
                      type="text"
                      v-model="item.measurementHeight"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Measurement-Width"
                    label-for="measurementWidth-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="measurementWidth-input"
                      type="text"
                      v-model="item.measurementWidth"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Measurement-Depth"
                    label-for="measurementDepth-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="measurementDepth-input"
                      type="text"
                      v-model="item.measurementDepth"
                    ></b-form-input>
                  </b-form-group>


                  <b-form-group
                    class="mb-3"
                    label="Brand Name"
                    label-for="brandName-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="brandName-input"
                      type="text"
                      v-model="item.brandName"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Manufacturer"
                    label-for="manufacturer-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="manufacturer-input"
                      type="text"
                      v-model="item.manufacturer"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Model Number"
                    label-for="modelNumber-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="modelNumber-input"
                      type="text"
                      v-model="item.modelNumber"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Serial Number"
                    label-for="serialNumber-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="serialNumber-input"
                      type="text"
                      v-model="item.serialNumber"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Description"
                    label-for="description-input"
                    label-cols-lg="4"
                  >
                    <b-form-textarea
                      id="description-input"
                      v-model="item.description"
                      :maxlength="400"
                    ></b-form-textarea>
                    <small class="text-muted">Characters left: {{ 400 - item.description.length }}</small>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Note"
                    label-for="note-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="note-input"
                      type="text"
                      v-model="item.note"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Purchase Price$"
                    label-for="approximatePrice-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="approximatePrice-input"
                      type="number"
                      v-model="item.approximatePrice"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Appraisal Value$"
                    label-for="appraisalValue-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="appraisalValue-input"
                      type="number"
                      v-model="item.appraisalValue"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Per Piece or Per Set"
                    label-for="perPieceOrPerSet-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="perPieceOrPerSet-input"
                      v-model="item.perPieceOrPerSet"
                      :options="perPieceOrPerSetOptions"
                      @change="onPerPieceOrPerSetChange"
                    ></b-form-select>
                    <b-form-input
                      v-if="item.perPieceOrPerSet === 'Other'"
                      id="otherPerPieceOrPerSet-input"
                      type="text"
                      v-model="otherPerPieceOrPerSet"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Number of Items in Set"
                    label-for="numberOfItems-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="numberOfItems-input"
                      type="number"
                      v-model="item.numberOfItems"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Year Purchased"
                    label-for="yearPurchased-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="yearPurchased-input"
                      type="text"
                      v-model="item.yearPurchased"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Month Purchased"
                    label-for="monthPurchased-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="monthPurchased-input"
                      v-model="item.monthPurchased"
                      :options="monthOptions"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="Country of Origin"
                    label-for="country-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="country-input"
                      type="text"
                      v-model="item.country"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Warranty Years"
                    label-for="warrantyYears-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="warrantyYears-input"
                      type="text"
                      v-model="item.warrantyYears"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Service Contract Company"
                    label-for="serviceContractCompany-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="serviceContractCompany-input"
                      type="text"
                      v-model="item.serviceContractCompany"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Extended Warranty Company"
                    label-for="extendedWarrantyCompany-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="extendedWarrantyCompany-input"
                      type="text"
                      v-model="item.extendedWarrantyCompany"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Heir Assigned Name"
                    label-for="heirAssignedName-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="heirAssignedName-input"
                      type="text"
                      v-model="item.heirAssignedName"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Actual Cash Value$"
                    label-for="actualCashValue-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="actualCashValue-input"
                      type="number"
                      v-model="item.actualCashValue"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Replacement Cost Value$"
                    label-for="replacementCostValue-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="replacementCostValue-input"
                      type="number"
                      v-model="item.replacementCostValue"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Auction Value$"
                    label-for="auctionValue-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="auctionValue-input"
                      type="number"
                      v-model="item.auctionValue"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    label="Retail Value$"
                    label-for="retailValue-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="retailValue-input"
                      type="number"
                      v-model="item.retailValue"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="Asset OwnerShip Status"
                    label-for="assetOwnershipStatus-input"
                    label-cols-lg="4"
                  >
                    <b-form-select
                      id="assetOwnershipStatus-input"
                      v-model="item.assetOwnershipStatus"
                      :options="assetOwnershipStatusOptions"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label="Asset Assigned To"
                    label-for="assetAssignedTo-input"
                    label-cols-lg="4"
                  >
                    <b-form-input
                      id="assetAssignedTo-input"
                      type="text"
                      v-model="item.assetAssignedTo"
                    ></b-form-input>
                  </b-form-group>
                </form>
              </div>
            </b-modal>
          </div>
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>
